import React from "react";

import "./Footer.css";

const YEAR = Math.max(2023, new Date().getFullYear());

const Footer = () => (
  <footer className="Footer">
    &copy;{YEAR} Ben Joffe &middot;{" "}
    <a href="https://twitter.com/benjoffe" target="_blank" rel="noreferrer">
      Follow&nbsp;me&nbsp;on&nbsp;Twitter
    </a>{" "}
    &middot; <a href="https://benjoffe.com">benjoffe.com</a>
  </footer>
);

export default Footer;
